import { ReactNode } from 'react';

import { IconAngleLeft } from '@iwoca/icons';
import { Link } from '@iwoca/orion';
import { getCurrentLocation } from '@iwRouter/HistoryProvider';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { getQueryParameter } from '@iwRouter/LocationHelper';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { buildLocationWithSearch } from '../../drawDown/DrawDownHelper';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    goBack: ({
        returnPath,
        drawdownAmount,
        offerId,
        sweep,
        urlReturnPath
    }: {
        returnPath: string | undefined;
        drawdownAmount: string | undefined;
        offerId: string | undefined;
        sweep: string | undefined;
        urlReturnPath: string | undefined;
    }) => {
        if (returnPath) {
            dispatch({
                type: REQUEST_CHANGE_ROUTER,
                //@ts-ignore
                location: buildLocationWithSearch({
                    pathname: returnPath,
                    offerId,
                    amount: drawdownAmount,
                    sweep,
                    returnPath: urlReturnPath
                })
            });
        } else {
            dispatch({
                type: REQUEST_CHANGE_ROUTER,
                location: { pathname: '/' }
            });
        }
    }
});

const FundingHeader = ({
    header,
    subHeader,
    returnPath,
    goBack,
    hideBackButton
}: {
    header: ReactNode;
    subHeader: ReactNode;
    returnPath?: string;
    hideBackButton?: boolean;
} & ReturnType<typeof mapDispatchToProps>) => {
    const location = getCurrentLocation();

    const drawdownAmount = getQueryParameter(location, 'amount');
    const sweep = getQueryParameter(location, 'sweep');
    const urlReturnPath = getQueryParameter(location, 'returnPath');
    const offerId: string | undefined = getQueryParameter(location, 'offerId');

    return (
        <div className="pb-m min-l:m-auto min-l:max-w-[70%] min-l:pb-xl">
            <div className="p-m min-l:px-4xl min-l:pb-2xl min-l:pt-5xl">
                <div
                    data-testid="funding-requirements-header"
                    className="text-center font-bold min-m:text-2xl min-l:my-l min-l:flex-row"
                >
                    {header}
                </div>
                <div className="text-center text-s font-reg min-l:text-m">
                    {subHeader}
                </div>
            </div>
            {!hideBackButton && (
                <Link
                    className="ml-m min-l:ml-5xl"
                    onClick={() =>
                        goBack({
                            returnPath,
                            drawdownAmount,
                            offerId,
                            sweep,
                            urlReturnPath
                        })
                    }
                >
                    <IconAngleLeft />
                    <FormattedMessage
                        id="_.funding_requirements.back_button"
                        defaultMessage="Go back"
                    />
                </Link>
            )}
        </div>
    );
};
// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(FundingHeader);
